<template>
  <div>
    <div class="nav_pos">
      当前位置：
      <label class="index" @click.stop="$router.push('/')">首页</label>
      > 关于我们
    </div>
    <!-- <div class="nav_pos"> -->
    <!-- <span class="text">当前位置：</span> -->
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-for="(item, index) in $route.meta.breadUrl" :key="index">
            <router-link v-if="item.url" :to="item.url">{{item.name}}</router-link>
            <a v-else>
              {{item.name}}
            </a>
          </el-breadcrumb-item>
      </el-breadcrumb> -->
    <!-- </div> -->
    <div class="aboutus top_line">
      <!-- <LeftTab :info="info" @switchCon="switchPage"></LeftTab> -->
      <div class="lefttab_wrap">
        <div class="title clear">
          <img :src="info.imgUrl" class="fl img" />
          <div class="text">
            <span>{{ info.text }}</span>
            <p class="egtext">{{ info.egText }}</p>
          </div>
        </div>
        <div v-if="info.tabList.length > 0">
          <el-tabs v-model="aboutTab" class="tab_wrap3" tab-position="left" @tab-click="switchPage">
            <el-tab-pane v-for="(item, index) in info.tabList" :key="index" :label="item.text" :name="item.UrlName"></el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="right_wrap" :is="currentView"></div>
    </div>
  </div>
</template>

<script>
import LeftTab from '@/components/common/LeftTab'
import Contact from '@/views/AboutUs/Contact'
import Introduce from '@/views/AboutUs/Introduce'
// import Question from "@/views/AboutUs/Question"
export default {
  name: 'aboutUs',
  components: { LeftTab, Contact, Introduce },
  data() {
    return {
      currentView: 'Introduce',
      aboutTab: '',
      info: {
        imgUrl: require('../../assets/img/icon_aboutus.png'),
        text: '关于我们',
        egText: 'About Us',
        tabList: [
          { text: '公司简介', UrlName: 'Introduce' },
          { text: '联系我们', UrlName: 'Contact' }
          // {"text":"常见问题","UrlName":"Question"},
          // {"text":"法律声明","UrlName":"Lawer"},
        ]
      }
    }
  },
  computed: {},
  mounted() {
    if (this.$route.query.UrlName) {
      this.aboutTab = this.$route.query.UrlName
      this.currentView = 'Contact'
    } else {
      this.aboutTab = this.info.tabList[0].UrlName
    }
  },
  methods: {
    switchPage(data) {
      this.currentView = data.name
    }
  }
}
</script>
<style scoped lang="scss">
.lefttab_wrap {
  width: 260px;
  margin-right: 25px;
  display: inline-block;
  .title {
    width: 220px;
    background: #0774c5;
    color: #fff;
    padding: 40px 20px;
    .text {
      position: relative;
      display: inline-block;
      font-size: 28px;
      padding-left: 40px;
      .egtext {
        color: #00ccf6;
        font-size: 18px;
        margin-top: 2px;
      }
    }
    .text:after {
      position: absolute;
      clear: both;
      content: '';
      width: 1px;
      height: 40px;
      display: block;
      left: 19px;
      top: 0;
      background: #fff;
    }
  }
}
</style>
